module.exports = __webpack_public_path__ + "static/media/delete_icon.55492980.svg";